<div class="content-wrapper table-full-bx">
    <div class="page-content account-settings">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox ">
                    <div class="ibox-body">
                        <div class="iboxcontent">
                            <h3>Account Settings</h3>
                        </div>
                        <!-- Account settings  -->
                        <div class="row">
                            <div class="col-md-12 col-lg-2 col-sm-12">
                                <!-- Tabs nav -->
                                <div class="nav nav-pills nav-pills-custom pills-custom">
                                    <a class="nav-link mb-3 p-3 active" href="javascript:void(0);"
                                        routerLink="/account-settings/change-password">
                                        <span class="">Change password</span>
                                    </a>

                                    <a class="nav-link mb-3 p-3 " href="javascript:void(0);">

                                        <span class=" ">Notifications</span>
                                    </a>

                                    <a class="nav-link mb-3 p-3 " href="javascript:void(0);">

                                        <span class=" ">Saved cards</span>
                                    </a>



                                    <a class="nav-link mb-3 p-3 " href="javascript:void(0);">

                                        <span class="">Subscriptions</span>
                                    </a>
                                    <a class="nav-link mb-3 p-3 " href="javascript:void(0);">

                                        <span class=" ">Billing address</span>
                                    </a>

                                    <a class="nav-link mb-3 p-3 " href="javascript:void(0);">

                                        <span class=" ">My templates</span>
                                    </a>

                                </div>
                            </div>
                            <div class="col-md-9 col-lg-9 col-sm-12">
                                <!-- Tabs content -->
                                <!-- <app-change-password></app-change-password> -->
                            </div>

                        </div>

                    </div>
                    <!-- End -->
                </div>
            </div>
        </div>
    </div>
</div>